export enum EEstado {
  EMITIDO = 1,
  EN_PROCESO = 2,
  CERRADO = 3,
}
